export default {
  name: 'TrashIcon',
  functional: true,
  props: {
    color: {
      type: String,
      default: 'currentColor'
    }
  },
  render(h, ctx) {
    return h('svg', {
      attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 448 512',
        fill: ctx.props.color,
        ...ctx.data.attrs
      },
      on: ctx.listeners
    }, [
      h('path', {
        attrs: {
          d: 'M135.2 17.7L121 32H24C10.7 32 0 42.7 0 56s10.7 24 24 24h400c13.3 0 24-10.7 24-24S437.3 32 424 32h-97L312.8 17.7C307.1 6.9 295.9 0 283.4 0H164.6c-12.5 0-23.7 6.9-29.4 17.7zM53.2 467c1.8 25 22.7 45 47.7 45h246.2c25 0 45.9-20 47.7-45L416 128H32l21.2 339zM200 224v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-8.8 7.2-16 16-16s16 7.2 16 16z'
        }
      })
    ]);
  }
};



// WEBPACK FOOTER //
// ./src/assets/icons/TrashIcon.js